module.exports = __webpack_public_path__ + "static/img/1692694691877.c1cae739.jpg";